/* eslint-disable import/prefer-default-export */

export const ADD_TERRITORY = 'ADD_TERRITORY';
export const ADD_PRODUCT_VARIANT_CODE = 'ADD_PRODUCT_VARIANT_CODE';
export const ADD_CONTENT_ENTITLEMENT = 'ADD_CONTENT_ENTITLEMENT';
export const ADD_TOCS_APP = 'ADD_TOCS_APP';
export const ADD_PRODUCT_CONFIGURATION = 'ADD_PRODUCT_CONFIGURATION';
